import { render } from "./index.vue?vue&type=template&id=2c9476c3&scoped=true"
import script from "./index.js?vue&type=script&lang=js"
export * from "./index.js?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2c9476c3&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=2c9476c3&lang=scss"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9476c3"]])

export default __exports__